var _rect, _rect2, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 100,
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 36,
    width: 13,
    height: 27,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 36,
    width: 13,
    height: 27,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_109_5",
    transform: "scale(0.00990099 0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_109_5",
    width: 101,
    height: 100,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.77f1a86889db089ae3d4387228679de7.svg";
export { ForwardRef as ReactComponent };